import { NavLink } from "react-router-dom";

// Constants
import { RoutePaths } from "Constants/RoutePaths";

// Components
import NavLinkBlackButton from "Components/UI/Buttons/NavLinkBlackButton";
import PrimaryText from "Components/UI/Text/PrimaryText";
import ImageLazyLoad from "Components/UI/ImageLazyLoad";
import ArticleDTO from "../../../../Models/DTOs/ArticleDTO";
import {toGBDate} from "../../../../Helpers/DataTypesGeneral/DateAndTime";

const ArticleGridItemSingle = (props: { article: ArticleDTO }) => {
    const redirect = props.article
        ? RoutePaths.ReadArticle(props.article.id)
        : null;
    return (
        <div className="article__grid-item-single">
            <NavLink className="image-container" to={redirect != null ? redirect : "/"}>
                <ImageLazyLoad source={props.article.header ?? ""} />

                <NavLinkBlackButton>Read Article</NavLinkBlackButton>
            </NavLink>

            <PrimaryText>{toGBDate(props.article.releaseDate)}</PrimaryText>

            <h3>
                <NavLink to={redirect != null ? redirect : "/"}>
                    {props.article.title}
                </NavLink>
            </h3>
        </div>
    );
};

export default ArticleGridItemSingle;
